import { useGameStore } from '@/state/gameStore';
import { getTutorialStep, TUTORIAL_DONE } from '@/domain/tutorial';
import './TutorialOverlay.css';

/**
 * Floating hint card that surfaces the current FTUE step. Self-positions
 * based on the step's `pointAt` field (bottom-nav-dungeon, combat-hud, etc.)
 * so the player's eye is drawn to the right region without us needing a
 * literal DOM-anchor refactor.
 *
 * The overlay is non-modal — it sits on top of gameplay but doesn't block
 * input. Player advances by performing the suggested action (auto-event)
 * or by tapping "Verstanden" (manual advance) / "Tutorial überspringen"
 * (jump to TUTORIAL_DONE).
 */
export function TutorialOverlay() {
  const player = useGameStore((s) => s.player);
  const advanceTutorial = useGameStore((s) => s.advanceTutorial);
  const skipTutorial = useGameStore((s) => s.skipTutorial);

  if (!player) return null;
  const step = player.tutorialStep ?? 0;
  if (step >= TUTORIAL_DONE) return null;
  const def = getTutorialStep(step);
  if (!def) return null;

  return (
    <div className={`tutorial-overlay tutorial-overlay--${def.pointAt}`}>
      <div className="tutorial-overlay__card">
        <div className="tutorial-overlay__step">
          Schritt {step + 1} / 6
        </div>
        <div className="tutorial-overlay__title">{def.title}</div>
        <div className="tutorial-overlay__body">{def.body}</div>
        <div className="tutorial-overlay__actions">
          <button
            type="button"
            className="tutorial-overlay__skip"
            onClick={skipTutorial}
          >
            Tutorial überspringen
          </button>
          <button
            type="button"
            className="tutorial-overlay__next"
            onClick={() => advanceTutorial(step + 1)}
          >
            Verstanden
          </button>
        </div>
      </div>
    </div>
  );
}
